import React from "react";
import beyondIcon from "../../../../../assets/images/report_caseAnalysis_beyond.svg";
import meetIcon from "../../../../../assets/images/meetIcon.svg";
import belowIcon from "../../../../../assets/images/report_caseAnalysis_below.svg";
import { StatusLevel } from "../../../types";

interface EvaluationStatusProps {
  status: StatusLevel;
}

const EvaluationStatus: React.FC<EvaluationStatusProps> = ({ status }) => {
  const getStatusSymbol = (status: StatusLevel) => {
    // Handle null or undefined cases
    if (!status) {
      return <span>N/A</span>;
    }

    const normalized = status.toLowerCase();

    // Check for "exceeds" variations
    if (normalized.includes("exceed") || normalized.includes("beyond")) {
      return <img src={beyondIcon} alt="Beyond Expectations" />;
    }

    // Check for "below" variations
    if (normalized.includes("below") || normalized.includes("develop")) {
      return <img src={belowIcon} alt="Below Expectations" />;
    }

    // Check for "meets" variations
    if (normalized.includes("meet")) {
      return <img src={meetIcon} alt="Meets Expectations" />;
    }

    // Fallback for unrecognized status
    return <span className="text-[var(--color-primary)]">{status}</span>;
  };

  return <div className="flex items-center">{getStatusSymbol(status)}</div>;
};

export default EvaluationStatus;
